// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Plain divs and tables only: public/css/index.css restyles bare article/aside/section under
   div.page at any depth, so this screen deliberately uses none of them. */
.nlm-root {
    max-width: 860px;
}

.nlm-quota,
.nlm-switch,
.nlm-empty {
    margin: 0 0 16px;
}

.nlm-hint {
    color: #666;
    display: block;
    margin-top: 4px;
}

[data-theme="dark"] .nlm-hint {
    color: #b8b8b8;
}

.nlm-empty {
    border: 1px solid #ddd;
    border-radius: 4px;
    padding: 12px 16px;
}

[data-theme="dark"] .nlm-empty {
    border-color: var(--color-border);
}

.nlm-composer textarea,
.nlm-composer input[type="text"] {
    box-sizing: border-box;
    width: 100%;
}

.nlm-actions {
    align-items: center;
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
    margin-top: 12px;
}

.nlm-payment a.button,
.nlm-payment a.button:hover {
    color: #fff;
}

.nlm-credits {
    border: 1px solid currentColor;
    border-radius: 4px;
    margin: 16px 0;
    padding: 16px;
}

.nlm-pack-choices {
    border: 0;
    margin: 12px 0;
    padding: 0;
}

.nlm-pack-choices legend {
    font-weight: bold;
}

.nlm-heading-actions {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 1.33em 0;
}

.nlm-heading-actions h4 {
    margin: 0;
}

.nlm-heading-actions .nlm-reload {
    background: transparent;
    border: 0;
    color: inherit;
    cursor: pointer;
    font: inherit;
    padding: 4px;
}

.nlm-heading-actions .nlm-reload:disabled {
    cursor: wait;
    opacity: 0.5;
}

.nlm-pack-choices .checkbox {
    display: flex;
    gap: 8px;
    margin: 12px 0;
}

.nlm-text-action {
    background: none;
    border: 0;
    color: inherit;
    cursor: pointer;
    font: inherit;
    text-decoration: underline;
}

.nlm-table-wrap {
    overflow-x: auto;
}

.nlm-history {
    border-collapse: collapse;
    width: 100%;
}

.nlm-history th,
.nlm-history td {
    border-bottom: 1px solid #eee;
    padding: 8px;
    text-align: left;
    vertical-align: top;
}

[data-theme="dark"] .nlm-history th,
[data-theme="dark"] .nlm-history td {
    border-bottom-color: var(--color-border-soft);
}

.nlm-schedule {
    border: 0;
    margin: 0 0 12px;
    padding: 0;
}

.nlm-schedule legend {
    font-weight: bold;
    padding: 0;
}

.nlm-choices {
    display: flex;
    flex-wrap: wrap;
    gap: 16px;
    margin: 4px 0 8px;
}

.nlm-error {
    color: #b3261e;
    display: block;
    margin-top: 4px;
}

[data-theme="dark"] .nlm-error {
    color: #ff8a80;
}

.nlm-cancel {
    display: block;
    margin-top: 6px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Seller/Newsletters/NewslettersManager.css"],"names":[],"mappings":"AAAA;0EAC0E;AAC1E;IACI,gBAAgB;AACpB;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;;IAEI,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,mBAAmB;IACnB,aAAa;IACb,SAAS;IACT,eAAe;IACf,gBAAgB;AACpB;;AAEA;;IAEI,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,SAAS;IACT,cAAc;IACd,UAAU;AACd;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,uBAAuB;IACvB,SAAS;IACT,cAAc;IACd,eAAe;IACf,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,SAAS;IACT,cAAc;IACd,eAAe;IACf,aAAa;IACb,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;;IAEI,6BAA6B;IAC7B,YAAY;IACZ,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;;IAEI,6CAA6C;AACjD;;AAEA;IACI,SAAS;IACT,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,iBAAiB;IACjB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,eAAe;IACf,SAAS;IACT,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB","sourcesContent":["/* Plain divs and tables only: public/css/index.css restyles bare article/aside/section under\n   div.page at any depth, so this screen deliberately uses none of them. */\n.nlm-root {\n    max-width: 860px;\n}\n\n.nlm-quota,\n.nlm-switch,\n.nlm-empty {\n    margin: 0 0 16px;\n}\n\n.nlm-hint {\n    color: #666;\n    display: block;\n    margin-top: 4px;\n}\n\n[data-theme=\"dark\"] .nlm-hint {\n    color: #b8b8b8;\n}\n\n.nlm-empty {\n    border: 1px solid #ddd;\n    border-radius: 4px;\n    padding: 12px 16px;\n}\n\n[data-theme=\"dark\"] .nlm-empty {\n    border-color: var(--color-border);\n}\n\n.nlm-composer textarea,\n.nlm-composer input[type=\"text\"] {\n    box-sizing: border-box;\n    width: 100%;\n}\n\n.nlm-actions {\n    align-items: center;\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n    margin-top: 12px;\n}\n\n.nlm-payment a.button,\n.nlm-payment a.button:hover {\n    color: #fff;\n}\n\n.nlm-credits {\n    border: 1px solid currentColor;\n    border-radius: 4px;\n    margin: 16px 0;\n    padding: 16px;\n}\n\n.nlm-pack-choices {\n    border: 0;\n    margin: 12px 0;\n    padding: 0;\n}\n\n.nlm-pack-choices legend {\n    font-weight: bold;\n}\n\n.nlm-heading-actions {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n    margin: 1.33em 0;\n}\n\n.nlm-heading-actions h4 {\n    margin: 0;\n}\n\n.nlm-heading-actions .nlm-reload {\n    background: transparent;\n    border: 0;\n    color: inherit;\n    cursor: pointer;\n    font: inherit;\n    padding: 4px;\n}\n\n.nlm-heading-actions .nlm-reload:disabled {\n    cursor: wait;\n    opacity: 0.5;\n}\n\n.nlm-pack-choices .checkbox {\n    display: flex;\n    gap: 8px;\n    margin: 12px 0;\n}\n\n.nlm-text-action {\n    background: none;\n    border: 0;\n    color: inherit;\n    cursor: pointer;\n    font: inherit;\n    text-decoration: underline;\n}\n\n.nlm-table-wrap {\n    overflow-x: auto;\n}\n\n.nlm-history {\n    border-collapse: collapse;\n    width: 100%;\n}\n\n.nlm-history th,\n.nlm-history td {\n    border-bottom: 1px solid #eee;\n    padding: 8px;\n    text-align: left;\n    vertical-align: top;\n}\n\n[data-theme=\"dark\"] .nlm-history th,\n[data-theme=\"dark\"] .nlm-history td {\n    border-bottom-color: var(--color-border-soft);\n}\n\n.nlm-schedule {\n    border: 0;\n    margin: 0 0 12px;\n    padding: 0;\n}\n\n.nlm-schedule legend {\n    font-weight: bold;\n    padding: 0;\n}\n\n.nlm-choices {\n    display: flex;\n    flex-wrap: wrap;\n    gap: 16px;\n    margin: 4px 0 8px;\n}\n\n.nlm-error {\n    color: #b3261e;\n    display: block;\n    margin-top: 4px;\n}\n\n[data-theme=\"dark\"] .nlm-error {\n    color: #ff8a80;\n}\n\n.nlm-cancel {\n    display: block;\n    margin-top: 6px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
